module.exports = __webpack_public_path__ + "0af5d249/img/settings-ico.a214628d.svg";